import State from './state'
import request from './request'
import axios from 'axios'
import { BROWSER_NAME, BROWSER_VERSION, OPERATING_SYSTEM } from './constants/platform'
import { HEADERS } from './constants/network'

export function fetchVisit() {
  console.log("fetchVisit()")
  return request('/').then(response => {
    State.setState(response.data)
  })
}

export function getMedicationSearchList(params) {
  return axios.create({
    headers: HEADERS,
    baseURL: `/`
  }).get('api/telemedicine/intakes/get_medication_search_list', { params: params })
}

export function getAllergySearchList(params) {
  return axios.create({
    headers: HEADERS,
    baseURL: `/`
  }).get('api/telemedicine/intakes/get_allergy_search_list', { params: params })
}

export function startVisit() {
  State.setState({
    visit: {
      patientJoinedAt: new Date(),
      advisorJoinedAt: new Date()
    }
  })
}

export function endVisit() {
  State.setState({
    visit: {
      concludedAt: new Date()
    }
  })
}

export function shiftParticipation(person, delta) {
  let participants = State.getState('video.participants')
  let advisorPresent = State.getState('advisor.present')
  let patientPresent = State.getState('patient.present')

  participants = Math.max(0, participants + delta)

  if (participants == 0 && advisorPresent && patientPresent) {
    //return before updating state to prevent a 0 participant count when
    //both the advisor and patient are present
    //this fixes a bug where the advisor wasn't seeing the patient
    //but the patient was still able to see the advisor
    return true
  }

  State.setState({
    video: { participants },
    [person.role]: {
      joined: participants > 0
    }
  })
}